import { Component } from "@angular/core";
import {
  PageToolbarItemType,
  PageTooolbarItem
} from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item";

@Component({
  selector: "snt-page-toolbar-item",
  template: "",
  standalone: false
})
export class PageToolbarItemComponent implements PageTooolbarItem {
  type: PageToolbarItemType = "item";
}
